import { initializeApp } from 'firebase/app';
import {
	getMessaging,
	onMessage,
	getToken,
	isSupported,
} from '@firebase/messaging';
import { useAccountStore } from 'src/stores/account';
import { userPushTokenUpdate } from 'src/lib/api';
import { Dialog } from 'quasar';

isSupported().then((value) => {
	if (!value) return;

	const firebaseConfig = {
		apiKey: 'AIzaSyDVcCT1jvfD-T82OR4Y1-1_TIbETFZZAxw',
		authDomain: 'its-macros.firebaseapp.com',
		projectId: 'its-macros',
		storageBucket: 'its-macros.appspot.com',
		messagingSenderId: '332242019992',
		appId: '1:332242019992:web:512ed0ac7b63bb5436d2ed',
		measurementId: 'G-0M1CBH6VZW',
	};

	const app = initializeApp(firebaseConfig);
	const messaging = getMessaging(app);

	Notification.requestPermission().then((permission) => {
		if (permission === 'granted') {
			getToken(messaging).then((token) => {
				if (!token) return;
				const accountStore = useAccountStore();
				if (accountStore.userId)
					userPushTokenUpdate(
						accountStore.userId,
						{
							push_token: token,
						},
						{
							headers: {
								Authorization: `Bearer ${accountStore.token}`,
							},
						}
					);
				accountStore.pushToken = token;
			});
		}
	});

	onMessage(messaging, function (payload) {
		console.log('On message ' + JSON.stringify(payload));

		const title = payload.notification?.title ?? '';
		const body = payload.notification?.body ?? '';

		if (!title || !body) return;

		Dialog.create({
			title,
			message: `<div style="display:flex; gap: 16px">
				<img style="border-radius: 8px" src="app-icon.png" alt="" width="32px" height="32px" />
				<p>${body}</p>
			</div>`,
			html: true,
		});
	});
});
